import { ITEM_TYPE_DEFAULT, ITEM_TYPE_DROPDOWN, ITEM_TYPE_SIMPLE } from '../draggable-item/draggable-item-controller';

export const LIST_TYPE_SINGLE = 0;
export const LIST_TYPE_SORTABLE = 1;

export default class DraggableItemListController {
  static $inject = ['$timeout', '$scope'];

  items: Array<string>;
  itemType = ITEM_TYPE_DEFAULT;
  contextId: string;
  additionalText: string;
  selectedGroupListItem: { [$listId: number]: string };
  onGroupListItemSelect: (args: { $itemId: string; $listId: number }) => void;
  onGroupListItemTrigger: (args: { $itemId: string; $listId: number }) => void;
  onItemDragEnd: (args: { $evt: DragEvent; $itemId: string }) => void;
  onItemDragStart: (args: { $evt: DragEvent; $itemId: string }) => void;

  ITEM_TYPE_DEFAULT = ITEM_TYPE_DEFAULT;
  ITEM_TYPE_SIMPLE = ITEM_TYPE_SIMPLE;
  ITEM_TYPE_DROPDOWN = ITEM_TYPE_DROPDOWN;
  selectedItem = '';

  constructor(
    private $timeout: angular.ITimeoutService,
    private $scope: angular.IScope
  ) {}

  $onChanges = (changesObj) => {
    const { selectedGroupListItem } = changesObj;
    const listId = this.listId();

    if (selectedGroupListItem) {
      this.selectedItem = this.selectedGroupListItem[listId] || '';
    }
  };

  listId() {
    return this.$scope.$id;
  }

  handleItemSelection($id: string) {
    if (this.onGroupListItemSelect) {
      this.onGroupListItemSelect({ $itemId: $id, $listId: this.listId() });
    } else {
      this.$timeout(() => (this.selectedItem = $id));
    }
  }

  handleItemTrigger($id: string) {
    if (this.onGroupListItemTrigger) {
      this.onGroupListItemTrigger({ $itemId: $id, $listId: this.listId() });
    }
  }

  handleItemDragStart($evt: DragEvent, $id: string) {
    if (this.onItemDragStart) {
      this.onItemDragStart({ $evt, $itemId: $id });
    }
  }

  handleItemDragEnd($evt: DragEvent, $id: string) {
    if (this.onItemDragEnd) {
      this.onItemDragEnd({ $evt, $itemId: $id });
    }
  }
}
